import styled from 'styled-components';
import { mediaQueryMobileLargeMin, mediaQueryDesktopMin } from 'styleUtils';
export var CheckboxesBlocksWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-4gi990-0"
})(["display:flex;flex-direction:column;justify-content:start;width:100%;@media ", "{flex-direction:row;flex-wrap:wrap;}@media ", "{justify-content:space-between;}"], mediaQueryMobileLargeMin, mediaQueryDesktopMin);